"use client";

import { useEffect, useState } from "react";

import NewsCarousel from "./parts/NewsCarousel";

// "News, Events & Stories" — a draggable carousel of the latest blog posts on a
// neutral-900 band.
//
// Read summaries after the cached homepage paints. The feed stays fresh without
// requiring the entire homepage to render for each request.
export default function NewsSection({ locale }) {
  const [blogs, setBlogs] = useState(null);

  useEffect(() => {
    const controller = new AbortController();
    const load = async () => {
      try {
        const response = await fetch(
          `/api/home-news?locale=${encodeURIComponent(locale)}`,
          { cache: "no-store", signal: controller.signal },
        );
        if (!response.ok) throw new Error(`home news returned ${response.status}`);

        const data = await response.json();
        setBlogs(Array.isArray(data?.blogs) ? data.blogs : []);
      } catch {
        if (!controller.signal.aborted) setBlogs([]);
      }
    };

    load();
    return () => controller.abort();
  }, [locale]);

  if (blogs?.length === 0) return null;

  return (
    <section id="news" className="bg-neutral-900">
      <div className="mx-auto max-w-[1440px] px-6 py-24 md:px-10 md:py-28">
        {blogs === null ? <NewsSkeleton /> : <NewsCarousel blogs={blogs} />}
      </div>
    </section>
  );
}

function NewsSkeleton() {
  return (
    <div aria-hidden="true" className="animate-pulse">
      <div className="h-12 w-80 max-w-full rounded-lg bg-neutral-800" />
      <div className="mt-14 flex gap-4 overflow-hidden sm:gap-11">
        {Array.from({ length: 3 }, (_, index) => (
          <div key={index} className="w-[calc(100vw-4.5rem)] max-w-96 shrink-0">
            <div className="h-80 bg-neutral-800" />
            <div className="mt-3 h-6 w-3/4 rounded bg-neutral-800" />
          </div>
        ))}
      </div>
    </div>
  );
}
